import { PathWithId } from "@constellation-academy/epic-ui";
import { LimitedCartDiscountEditPath } from "../limited-cart-discount-edit/limited-cart-discount-edit.paths";

export class LimitedCartDiscountsPath extends PathWithId<typeof LimitedCartDiscountsPath> {
	static readonly pathKey = "cartDiscounts";
	static readonly pathName = "cart-discounts";
	static readonly idKey = "cartDiscountId";
	static readonly childPaths = [LimitedCartDiscountEditPath];
}
